import { produce } from "immer";
import * as Actions from "pages/Archive/store/singleArchiveActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [] };
const singleArchiveReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_SINGLE_ARCHIVE_SUCCESS: {
      const payload = action.payload;
      const singleArchive = payload.singleArchive;
      const singleArchiveId = payload.id;

      const allIds = [singleArchiveId];
      const byId = {
        [singleArchiveId]: singleArchive
      };

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });

      draft.allIds = deepmerge(draft.allIds, allIds, {
        arrayMerge: combineMerge
      });

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default singleArchiveReducer;
